export const FETCH_TESTS = "FETCH_TESTS";
export const SET_TESTS = "SET_TESTS";
export const ACCEPT_TEST = "ACCEPT_TEST";
export const FETCH_TESTS_EN_CURSO = "FETCH_TESTS_EN_CURSO";
export const SET_TESTS_EN_CURSO = "SET_TESTS_EN_CURSO";

export const GET_INVITATION_BY_ID = "GET_INVITATION_BY_ID";
export const SET_INVITATION_BY_ID = "SET_INVITATION_BY_ID";

export const GET_QUESTIONNAIRE_PAGE = "GET_QUESTIONNAIRE_PAGE";
export const SET_QUESTIONNAIRE_PAGE = "SET_QUESTIONNAIRES_PAGE";

export const PATCH_QUESTIONNAIRE_PAGE = "PATCH_QUESTIONNAIRE_PAGE";

export const INFORM_PROBLEM = "INFORM_PROBLEM";

export const fetchTests = values => ({
  type: FETCH_TESTS,
  payload: values
});

export const acceptTest = values => ({
  type: ACCEPT_TEST,
  payload: values
});

export const fetchTestsEnCurso = values => ({
  type: FETCH_TESTS_EN_CURSO,
  payload: values
});

export const patchQuestionnairePage = values => ({
  type: PATCH_QUESTIONNAIRE_PAGE,
  payload: values
});

export const getInvitationById = values => ({
  type: GET_INVITATION_BY_ID,
  payload: values,
});

export const getQuestionnairePage = values => ({
  type: GET_QUESTIONNAIRE_PAGE,
  payload: values
});

export const informProblem = values => ({
  type: INFORM_PROBLEM,
  payload: values
});


// WEBPACK FOOTER //
// ./src/redux/actions/sagaActions.js